<template>
  <div class="c-modal-ca" @click="$emit('close')">
    <div class="c-modal-ca__inner">
      <div class="c-modal-ca__container">
        <a href="#" class="c-modal-ca__close-button" @click.prevent.stop="$emit('close')">
          <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" svg-inline="" role="presentation" focusable="false" tabindex="-1"><path d="M6.768 5l2.866-2.866A1.25 1.25 0 107.866.366L5 3.232 2.134.366A1.25 1.25 0 10.366 2.134L3.232 5 .366 7.866a1.25 1.25 0 101.768 1.768L5 6.767l2.866 2.867c.244.244.564.366.884.366a1.25 1.25 0 00.884-2.134L6.768 5z" fill="#9e9ea7"></path></svg>
        </a>
        <div class="c-modal-ca__content-wrapper" @click.stop>
          <slot name="header" />
          <slot name="content" />
          <slot name="footer" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ModalCABase'
}
</script>

<style lang="stylus" scoped>
.c-modal-ca
  position fixed
  top 0
  left 0
  width 100%
  height 100%
  z-index 999999
  padding 40px
  overflow auto
  background rgba(30,30,30,0.9)
  
  &__inner
    position relative
    top 0
    left 0
    width 100%
    pointer-events none
    min-height 100%
    display flex
    align-items center

  &__container
    position relative
    width 100%
    z-index 9997
    background #fff
    margin 0 auto
    pointer-events auto
    border-radius 12px
    max-width 530px

  &__content-wrapper
    padding 32px
    text-align center

  &__close-button
    position absolute
    top 12px
    right 16px
    background none
    width auto
    height auto
    box-shadow none
    z-index 1
  &__close-button > svg
    width 12px
    height 12px

  @media (max-width 575px)
    padding 16px 12px
    &__content-wrapper
      padding 24px 20px
  @media (max-width 320px)
      padding 20px 16px
</style>
